import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  DocumentNumberingDto,
  DocumentNumberingListDto,
  DocumentNumberingFilterDto,
  CreateDocumentNumberingRequest,
  UpdateDocumentNumberingRequest,
} from '@/types/documentNumbering.types';

export const documentNumberingApi = {
  /** GET /api/v1/document-numberings — paginated list with optional search/filter */
  getList: (filter?: DocumentNumberingFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<DocumentNumberingListDto>>>('/document-numberings', {
      params: filter,
    }),

  /** GET /api/v1/document-numberings/{id} — full document numbering record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<DocumentNumberingDto>>(`/document-numberings/${id}`),

  /** GET /api/v1/document-numberings/by-transaction-type/{code} — lookup by transaction type code */
  getByTransactionType: (code: string) =>
    apiClient.get<ApiResponse<DocumentNumberingDto>>(
      `/document-numberings/by-transaction-type/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/document-numberings — create a new document numbering config */
  create: (data: CreateDocumentNumberingRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/document-numberings', data),

  /** PUT /api/v1/document-numberings/{id} — update document numbering config */
  update: (id: string, data: UpdateDocumentNumberingRequest) =>
    apiClient.put<ApiResponse<object>>(`/document-numberings/${id}`, data),

  /** DELETE /api/v1/document-numberings/{id} — soft-delete the document numbering config */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/document-numberings/${id}`),
};
